import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import TagSelect from "../tagSelect";
import { Button, Spin } from "antd";
import "antd/es/button/style/css";
import "antd/es/spin/style/css";
import { LoadingOutlined } from "@ant-design/icons";
import { StyleItem } from "@/services/workbench/types";
import { statTrack } from "@/utils/mtstat";
import {
  fetchPPTTemplate,
  fetchTemplateCenterInit,
} from "@/services/workbench";
import { getDesignHome } from "@/constants";
import Image from "next/image";
import { thumbnail } from "@/utils";

interface TemplatesProps {
  col: number;
  totalWidth: number;
  gap: number;
  width: number;
}

const Templates = (props: TemplatesProps) => {
  const [styleList, setStyleList] = useState<StyleItem[]>([]);
  const [active, setActive] = useState<string>("");
  const { col, totalWidth, gap, width } = props;
  const cursor = useRef("");
  const [list, setList] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const loadRef = useRef<HTMLDivElement>(null);
  const hasMoreRef = useRef(true);
  const isIntRef = useRef(true);
  const [show, setShow] = useState(true);
  const count = useRef("20");
  const [loading, setLoading] = useState(false);
  const [hasCursor, setHasCursor] = useState(false);

  const getList = async (id: string, init = false) => {
    try {
      setLoading(true);
      const res = (await getTemplates(id)) as any;
      console.log("【作图记录】：", res);
      setHasMore(!!res.data.data?.cursor);
      cursor.current = res.data.data?.cursor || "";
      setHasCursor(!!cursor.current);
      hasMoreRef.current = !!res.data.data?.cursor;
      if (init) {
        setList(res.data.data?.materials);
        return;
      }
      setList((oldList) => {
        return [...oldList, ...res.data.data?.materials];
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (list.length) {
      setShow(true);
    } else {
      setShow(false);
    }
    trackFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  useEffect(() => {
    getList("", true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trackFn = () => {
    const items = document.querySelectorAll(`.${styles.templatesListItem}`);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // 在这里，通常也可以用于埋点曝光统计
          const item = entry.target;
          if (item.getAttribute("data-track")) return;
          item.setAttribute("data-track", "1");
          statTrack("template_show", {
            industry_id: "",
            scene_id: "",
            topic: active,
            template_id: item.getAttribute("data-id"),
            entry: "aippt_home",
            type: 7,
          });
          observer.unobserve(item);
        }
      });
    });
    items.forEach((img) => observer.observe(img));
  };

  const getInitData = async () => {
    const res = await fetchTemplateCenterInit();
    setStyleList([
      {
        id: "",
        name: "全部",
      },
      ...res.data.data.styles,
    ]);
  };

  const getTemplates = async (id: string) => {
    return await fetchPPTTemplate({
      center_filter: JSON.stringify({
        sort: "normal",
        filter_ids: `2130${id ? "," + id : id}`,
      }),

      cursor: cursor.current,
      count: count.current,
    });
  };

  useEffect(() => {
    getInitData();
  }, []);
  return (
    <div
      className={styles.templatesWrap}
      style={{
        width: totalWidth,
      }}
    >
      <TagSelect
        list={styleList}
        active={active}
        config={{
          label: "name",
          value: "id",
        }}
        onTagSelect={(v) => {
          setHasMore(true);
          cursor.current = "";
          // setList([]);
          setActive(v);
          getList(v, true);
        }}
      />
      <div className={styles.templatesList}>
        {loading && (
          <div
            className={styles.templatesListLoading}
            style={{
              paddingTop: list.length ? "100px" : "0",
            }}
          >
            <Spin
              indicator={
                <LoadingOutlined style={{ fontSize: 48, color: "#fff" }} spin />
              }
            />
          </div>
        )}
        {list.map((item, i) => {
          // 计算出需要缩放的倍数
          const scale = width / item.thumbnail?.width;
          return (
            <div
              key={item.id}
              onClick={() => {
                statTrack("template_click", {
                  industry_id: "",
                  scene_id: "",
                  topic: active,
                  template_id: item.id,
                  entry: "aippt_home",
                  type: 7,
                });
                const url = `${getDesignHome()}/design`;
                window.open(`${url}?id=${item.id}&origin=ai-ppt`);
              }}
            >
              <div
                className={styles.templatesListItem}
                data-id={item.id}
                style={{
                  width: width,
                  // height: HEIGHT,
                  marginRight: (i + 1) % col === 0 ? 0 : gap,
                  // 第一行的 marginTop 为0，其他为24
                  marginTop: i < col ? 0 : 24,
                }}
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={thumbnail(item.thumbnail?.url || "")}
                  alt=""
                  width={width}
                  height={item.thumbnail?.height * scale}
                />
              </div>
            </div>
          );
        })}
      </div>

      {loading && (
        <div ref={loadRef} className={styles.templatesLoad}>
          加载中...
        </div>
      )}

      {!hasMore && (
        <div ref={loadRef} className={styles.templatesLoad}>
          没有更多了~
        </div>
      )}
      {hasMore && !loading && (
        <div className={styles.templatesLoadMore}>
          <Button onClick={() => getList(active)}>加载更多</Button>
        </div>
      )}
    </div>
  );
};

export default React.memo(Templates);
